import useVideoClipAsset, { UseVideoClipAssetProps } from './useVideoClipAsset';
import VideoClipAsset from './VideoClipAsset';

export default VideoClipAsset;
export { useVideoClipAsset, UseVideoClipAssetProps };
